export default "__VITE_ASSET__Bbn5ffYN__"